<template>
  <div class="login">
    <div class="login-box">
      <div class="login-bg"></div>
      <div class="login-input">
        <!-- <h2>登录</h2> -->
        <a-form :form="form" @submit.prevent="handleSubmit">
          <a-tabs default-active-key="0" @change="tabChange">
            <a-tab-pane key="0" tab="账号密码登录">
              <a-form-item v-bind="formItemLayout" label="">
                <a-input v-decorator="['username', decoratorOptions.username]" size="large" placeholder="请输入账号">
                  <a-icon slot="prefix" type="user"/>
                </a-input>
              </a-form-item>

              <a-form-item v-bind="formItemLayout" label="">
                <a-input-password v-decorator="['password', decoratorOptions.password]" type="password" size="large" autocomplete placeholder="请输入密码">
                  <a-icon slot="prefix" type="lock"/>
                </a-input-password>
              </a-form-item>

              <a-form-item class="captcha" v-bind="formItemLayout" label="">
                <a-input v-decorator="['code', decoratorOptions.code]" size="large" placeholder="请输入验证码">
                  <a-icon slot="prefix" type="global"/>
                </a-input>
                <div @click="getCaptcha" class="img-box">
                  <img :src="captchaUrl" alt=" ">
                </div>
              </a-form-item>
            </a-tab-pane>
            <a-tab-pane key="1" tab="手机号登录" force-render>
              <a-form-item v-bind="formItemLayout" label="">
                <a-input v-decorator="['phone', decoratorOptions.phone]" size="large" placeholder="请输入手机号">
                  <a-icon slot="prefix" type="mobile"/>
                </a-input>
              </a-form-item>
              <a-form-item v-bind="formItemLayout" label="">
                <a-input v-decorator="['smscode', decoratorOptions.smscode]" size="large" autocomplete placeholder="请输入验证码">
                  <a-icon slot="prefix" type="mail"/>
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-button @click="getCode">{{second && `${second}S`}} 获取验证码</a-button>
              </a-form-item>

            </a-tab-pane>
          </a-tabs>

          <a-form-item class="submit-btn" :wrapper-col="{ span: 19 }">
            <a-button type="primary" html-type="submit" block size="large" :loading="btnLoading.loading">登录</a-button>
          </a-form-item>
          <span @click="$router.push({name: 'forget'})" class="forget">忘记密码？</span>
        </a-form>
      </div>
    </div>
    <div class="record">
      <a href="https://beian.miit.gov.cn/" target="_blank"><p>闽ICP备17026099号</p></a>
    </div>
    <a-modal v-model="visible" title="请完成安全验证" :footer="null" @cancel="visible = false" width="358px">
      <slide-verify
          ref="slideblock"
          @again="onAgain"
          @fulfilled="onFulfilled"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          :accuracy="accuracy"
          slider-text="向右滑动完成验证"
      ></slide-verify>
      <div class="msg" :class="checkResult ? 'success' : ''">{{checkMsg}}</div>
    </a-modal>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
export default {
  name: 'login',
  data () {
    return {
      btnLoading: { loading: false },
      visible: false,
      formValues: {},
      checkMsg: '',
      checkResult: false,
      accuracy: 2, // 允许滑块误差值  为1则要完全重合。
      second: '',
      currentType: 0,
      uuid: '',
      captchaUrl: '',
      // redirect: '',
      formItemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 19 }
      },
      decoratorOptions: {
        username: {
          rules: [{ required: true, message: '请输入账号' }]
        },
        password: {
          rules: [{ required: true, message: '请输入密码' }]
        },
        code: {
          rules: [{ required: true, message: '请输入验证码' }]
        },
        phone: {
          rules: [
            { required: true, message: '请输入手机号' },
            { pattern: this.REG.mobile, message: this.MESSAGE.mobile }
          ]
        },
        smscode: {
          rules: [{ required: true, message: '请输入验证码' }]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.getCaptcha();
  },
  // watch: {
  //   $route: {
  //     handler: function (route) {
  //       this.redirect = route.query && route.query.redirect;
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    // 获取手机验证码
    getCode () {
      this.form.validateFields(['phone'], (err, values) => {
        if (err || this.second > 0) { return; }
        this.$get({
          url: 'userLogin/getSmsCode',
          params: { ...values, type: 3}
        }).then((res) => {
          this.$message.success('验证码获取成功！');
          this.second = 60;
          let countDown = setInterval(() => {
            if (this.second > 1) {
              this.second--;
            } else {
              clearInterval(countDown);
              this.second = '';
            }
          }, 1000);
        });
      });
    },
    tabChange (key) {
      this.currentType = key;
    },
    /* 获取验证码 */
    getCaptcha () {
      this.$get({
        url: 'captcha/getImage',
        params: {}
      }).then(({data}) => {
        this.captchaUrl = `${data.img}`;
        this.uuid = data.uuid;
      });
    },
    /* 提交登录 */
    handleSubmit () {
      let arr = [
        ['username', 'password', 'code'],
        ['phone', 'smscode']
      ];
      this.form.validateFields(arr[this.currentType], (err, values) => {
        if (err) { return; }
        values = { ...values };
        this.formValues = values;
        // this.visible = true;
        // this.$refs.slideblock.reset();

        this.onSuccess();
      });
    },
    // 滑块验证方法
    onSuccess (times) {
      let url = [
        `/userLogin/login?uuid=${this.uuid}&grantType=password&code=${this.formValues.code}`,
        '/userLogin/smsLogin'
      ];
      this.checkResult = true;
      this.checkMsg = `验证成功, 耗时${(times / 1000).toFixed(1)}s`;
      this.formValues.password = CryptoJS.MD5(this.formValues.password).toString();
      this.$post({
        url: url[this.currentType],
        params: this.formValues,
        btnLoading: this.btnLoading
      }).then(({ data }) => {
        this.onRefresh();
        this.visible = false;
        localStorage.refresh_token = data.refresh_token;
        this.setToken(data.access_token);
        this.$router.push({ path: '/community' }, () => {});
      }).catch((err) => {
        this.visible = false;
        let errData = err.data;
        if (typeof err.data === 'string') {
          errData = JSON.parse(errData);
        }
        if (errData.code === 500) {
          this.getCaptcha();
        }
      });
    },
    onFail () {
      this.checkResult = false;
      this.checkMsg = '验证失败,请重新验证';
    },
    onAgain () {
      this.$message.error('检测到非人为操作的哦, 请重新验证！');
      // 刷新
      this.$refs.slideblock.reset();
    },
    onRefresh () {
      this.checkMsg = '';
      this.checkResult = false;
    },
    onFulfilled () {
      this.onRefresh();
    }
  }
};
</script>

<style lang="scss">
@import "../../style/variable";

/* S-登录 */
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: url("../../assets/images/bg_denglu.png") no-repeat;
  background-size: cover;
  .login-box {
    display: flex;
    width: 950px;
    height: 550px;
    .login-bg {
      width: 430px;
      height: 100%;
      background: url("../../assets/images/bg_denglu2.png");
      background-size: cover;
    }
    .login-input {
      padding-left: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 550px;
      width: 500px;
      background-color: #fff;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      h2 {
        margin-top: 45px;
        margin-bottom: 43px;
        font-size: 28px;
        //color: $blue_1;
        letter-spacing: 0.62px;
      }
      .ant-input-prefix {
        font-size: 16px;
        color: $black_3;
      }
      .ant-input-affix-wrapper .ant-input:not(:first-child) {
        padding-left: 36px;
      }
      .ant-input-lg {
        font-size: 14px;
      }
      .submit-btn{
        margin-bottom: 15px;
      }
      .forget {
        font-size: 12px;
        letter-spacing: 0.27px;
        color: $gray_2;
        cursor: pointer;
      }
    }
  }
  .record {
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
    font-size: 12px;
    p {
      text-align: center;
      color: #eee;
      cursor: pointer;
    }
  }
}
/* E-登录 */

.captcha {
  .ant-form-item-children {
    display: inline-block;
    width: 100%;
    height: 40px;
    .img-box {
      position: absolute;
      right: 2px;
      top: -2px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      img {
        height: 36px;
      }
    }
  }
}
</style>
